import React from 'react'

import BodyRow from './BodyRow'
import { IBodyRow, onDoubleClick, onHoverPopup, onRowClassName, onRowHover } from './Types'

interface IBodyProps {
  content: IBodyRow[]
  onHover: onRowHover
  onHoverPopup?: onHoverPopup
  onDoubleClick: onDoubleClick
  onRowClassName?: onRowClassName
  rowHeight: number
  hovered: number | null
  fillerHeight?: number
}

function Body(props: IBodyProps) {
  const { content, fillerHeight, ...rest } = props

  return (
    <tbody data-testid='cbgms-grid-tbody' className='cgms-grid-tbody'>
      {content.map((row, i) => (
        <BodyRow key={i} row={row} {...rest} />
      ))}
      {Boolean(fillerHeight) && <tr style={{ height: fillerHeight }} />}
    </tbody>
  )
}

export default React.memo(Body)
